import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { QuantitySettingsService } from '../../services/QuantitySettingsService';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import { customStyles, the } from '../components/customStyles';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import ScriptDropdown from '../components/ScriptDropdown';


function QuantitySettings() {
  const [loading, setLoading] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState('');
  const [selectedScript, setSelectedScript] = useState('');
  const [quantitySettings, setQuantitySettings] = useState([]);
  const [qtySetting, setQtySetting] = useState(null);
  const [minOrder, setMinOrder] = useState('');
  const [maxOrder, setMaxOrder] = useState('');
  const [positionLimit, setPositionLimit] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const handleCopyClose = () => setShowCopyModal(false);
  const handleClose = () => setShowModal(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [userType, setUserType] = useState('CLIENT');
  
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');

  const handleSelectedClientChange = (selectedOption) => {
    setSelectedClient(selectedOption);
  };

  const handleCopyModal = () => {
    setUserType('CLIENT');
    setShowCopyModal(true);
  };

  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };

  const handleScriptReset = () => {
    setSelectedScript(null);
  };
  const handleGet = () => {
    if (!selectedClient) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Select Client!",
      });
      return;
    }
    setLoading(true);
    QuantitySettingsService.getQuantitySettings({ "userId": selectedClient.userId }).then(res => {
      setLoading(false);
      if (res.code === 1) {
        const user = res.data.quantitySettings.user;
        const details = res.data.quantitySettings.quantityDetails;

        if (details.length > 0) {
          const processedData = details.map(detail => ({
            ...detail,
            client: `${user.firstName} (${user.userName}) `,
            hiddenUserId: user.userid
          }));
          setQuantitySettings(processedData);
        } 
      } else {
        Swal.fire({
          icon: "error",
          text:  res.messages || "Something went wrong!",
        });
      }
    });
  };

  const handleAdd = () => {
    if (!selectedClient || !selectedMarket ||  !qtySetting || !minOrder || !maxOrder || !positionLimit) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fill in all required fields!',
      });
      return;
    }

    if (minOrder === '0' || maxOrder === '0' || positionLimit === '0') {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Values cannot be 0!',
      });
      return;
    }
    const requestData = {
      loginId: user.adminId,
      userId: selectedClient.userId,
      segment: selectedMarket,
      script: selectedScript || "ALL",
      type: qtySetting,
      minOrder: parseInt(minOrder, 10),
      maxOrder: parseInt(maxOrder, 10),
      positionLimit: parseInt(positionLimit, 10),
    };
    QuantitySettingsService.addQuantitySettings(requestData).then(res => {
      if (res.code === 1) {
        Swal.fire({
          icon: 'success',
          text: 'Added Successfully!',
        });
         handleGet();
        // setSelectedMarket('');
        // setSelectedScript('');
        setMinOrder('');
        setMaxOrder('');
        setPositionLimit('');
      } else {
        Swal.fire({
          icon: 'error',
          text: res.message || 'Failed to Add!',
        });
      }
    });

  }

  const handleReset = () => {
    setSelectedAdmin( null );
    setSelectedMaster(null);
    setSelectedBroker(null);
    setSelectedClient(null);
    handleSelectedClientChange(null);
    setSelectedBrokerId(null);
    setSelectedClientId(null);
    setSelectedMarket(null);
    setSelectedScript(null);
    setQtySetting(null);
    setMinOrder(null);
    setMaxOrder(null);
    setPositionLimit(null);
  };

  const handleUpdate = (updatedRow) => {
    if (updatedRow.minOrder === '0' || updatedRow.maxOrder === '0' || updatedRow.positionLimit === '0') {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Values cannot be 0!',
      });
      return;
    }
    const requestData = {
      loginId: user.adminId,
      userId: updatedRow.hiddenUserId,
      segment: updatedRow.segment,
      script: updatedRow.script,
      type: updatedRow.type,
      minOrder: parseInt(updatedRow.minOrder, 10),
      maxOrder: parseInt(updatedRow.maxOrder, 10),
      positionLimit: parseInt(updatedRow.positionLimit, 10),
    };

    QuantitySettingsService.addQuantitySettings(requestData).then((res) => {
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Updated Successfully!",
        });
        handleGet();
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          text: res.messages || "Failed to Update!",
        });
      }
    });
  };

  const handleDelete = (rowData) => {
    if (!rowData || !rowData.hiddenUserId) {
      Swal.fire({
        icon: "error",
        text: "Invalid row data!",
      });
      return;
    }

    const requestData = {
      loginId: user.adminId,
      userId: rowData.hiddenUserId,
      segment: rowData.segment,
      script: rowData.script,
    };

    QuantitySettingsService.deleteQuantitySettings(requestData).then((res) => {
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Deleted Successfully!",
        });
        handleGet();
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          text: res.messages || "Failed to Delete!",
        });
      }
    });
  };

  const handleCopySubmit = () => {
    if (!from && !to) {
      Swal.fire({
        icon: 'warning',
        text: 'Select From and To!',
      });
      return;
    }
    const requestData = {
      from: userType === 'CLIENT' ? from.userId: from.adminId, to: userType === 'CLIENT' ? to.userId : to.adminId,
      type: userType === 'CLIENT' ? 'USER' : userType,
      adminId: user.adminId
    };

    QuantitySettingsService.copyQuantitySettings(requestData).then((res) => {
      handleCopyClose(false);
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Copy Successfully!",
          timer: 1000
        });
      } else {
        Swal.fire({
          icon: "error",
          text: res.messages || "Failed to Copy!",
        });
      }
    });
  };

  useEffect(() => {
    const handlePencilClick = (event) => {
      const rowIndex = event.target.getAttribute("data-id");
      const rowData = quantitySettings[rowIndex];
      setSelectedRowData(rowData);
      setShowModal(true);
    };

    const handleTrashClick = (event) => {
      const rowIndex = event.target.getAttribute("data-id");
      const rowData = quantitySettings[rowIndex];

      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDelete(rowData);
        }
      });
    };


    document.addEventListener("click", (event) => {
      if (event.target.classList.contains("icon-pencil")) {
        handlePencilClick(event);
      } else if (event.target.classList.contains("icon-trash")) {
        handleTrashClick(event);
      }
    });

    return () => {
      document.removeEventListener("click", handlePencilClick);
      document.removeEventListener("click", handleTrashClick);
    };
  },);

  const columns = [
    {
      title: "CLIENT",
      data: "client",
    },
    {
      title: "MARKET",
      data: "segment",
    },
    {
      title: "SCRIPT",
      data: "script",
    },
    {
      title: "LIMIT TYPE",
      data: "type",
    },
    {
      title: "MIN ORDER",
      data: "minOrder",
    },
    {
      title: "MAX ORDER",
      data: "maxOrder",
    },
    {
      title: "POSITION LIMIT",
      data: "positionLimit",
    },
    {
      title: "ACTION",
      render: (data, type, row, full, meta) => {
        return `
        <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.row}" style="cursor: pointer"></i>
        <i class="icon-trash fa fa-trash" data-id="${full.row}" style="cursor: pointer; color: red"></i>
      `;
      },
    },
  ]

  return (
    <div>

      <Card className='mt-2'>
        <Card.Body>
          <Row>
            {user.adminType === 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col sm={2} xs={6}>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col sm={2} xs={6}>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}

                  />
                </Col>
              </> : ""}


            <Col sm={2} xs={6}>
              <b className="fss-05">CLIENT <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b></b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                setSelectedOption={handleSelectedClientChange}
              />

            </Col>

            <Col sm={2} xs={6}>
              <b className='fss-05'>MARKET <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b></b>
              <MarketDropdown
                allScripts={allScripts}
                onMarketChange={handleMarketChange} onScriptReset={handleScriptReset} />
            </Col>

            <Col sm={2} xs={6}>
              <b className='fss-05'>SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />
            </Col>
           
          </Row>

          <Row>
            <Col sm={2} xs={6}>
              <b className='fss-05'>QTY SETTING <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b></b>
              <Select
                isMulti={false}
                isClearable
                placeholder="Select"
                theme={the}
                styles={customStyles}
                options={[
                  { value: 'LOT', label: 'LOT' },
                  { value: 'QTY', label: 'QTY' }
                ]}
                value={qtySetting ? { value: qtySetting, label: qtySetting } : null}  // Ensure proper value binding
                onChange={(option) => setQtySetting(option?.value || null)}
              />

            </Col>

            <Col sm={2} xs={6}>
              <b className='fss-05'>MIN ORDER <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b></b>
              <Form.Control
                type='number'
                className='bg-light text-black'
                size="sm"
                value={minOrder}
                onChange={(e) => setMinOrder(e.target.value)}
              />
            </Col>
            <Col sm={2} xs={6}>
              <b className='fss-05'>MAX ORDER <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b></b>
              <Form.Control
                type='number'
                className='bg-light text-black'
                size="sm"
                value={maxOrder}
                onChange={(e) => setMaxOrder(e.target.value)}
              />
            </Col>
            <Col sm={2} xs={6}>
              <b className='fss-05'>POSITION LIMIT <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b></b>
              <Form.Control
                type='number'
                className='bg-light text-black'
                size="sm"
                value={positionLimit}
                onChange={(e) => setPositionLimit(e.target.value)}
              />
            </Col>
            <Col sm={4} className='mt-4 '>
              <Button variant="success" size="sm" className='me-2 w-25' onClick={handleAdd}>
                Add
              </Button>
              <Button variant="success" size="sm" className='me-2 ' onClick={handleGet}>
                Search
              </Button>
              <Button variant="danger" size="sm" className='me-2' onClick={handleReset}>
                Reset
              </Button>          
              <Button variant="success" size="sm" className='' onClick={handleCopyModal}>
                  Copy Settings
                </Button>
            </Col>

          </Row>

        </Card.Body>
      </Card>

      <Card className="mt-2 mb-5">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                id="table"
                className=" table  table-bordered bg-head-secondary fss-08 white-bordered-table text-center"
                columns={columns}
                data={quantitySettings}
              />
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Quantity Setting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRowData && (
            <>
              <lable>CLIENT:  {selectedRowData.client}</lable>
              <hr />
              <Row className='mt-2'>
                <Col>
                  <lable>MARKET: {selectedRowData.segment}</lable>
                </Col>
                <Col>
                  <lable>SCRIPT: {selectedRowData.script}</lable>
                </Col>
              </Row>

              <Row className='mt-2'>
                <Col>
                  <label>MIN ORDER</label>
                  <Form.Control
                    type="number"
                    value={selectedRowData.minOrder}
                    theme={the}
                    styles={customStyles}
                    className='bg-light text-black'
                    onChange={(e) =>
                      setSelectedRowData({ ...selectedRowData, minOrder: e.target.value })
                    }
                  />
                </Col>
                <Col>
                  <label>MAX ORDER</label>
                  <Form.Control
                    type="number"
                    value={selectedRowData.maxOrder}
                    theme={the}
                    styles={customStyles}
                    className='bg-light text-black'
                    onChange={(e) =>
                      setSelectedRowData({ ...selectedRowData, maxOrder: e.target.value })
                    }
                  />
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col>
                  <lable>LIMIT TYPE</lable>
                  <Select
                    value={{ value: selectedRowData.type, label: selectedRowData.type }}
                    theme={the}
                    styles={customStyles}
                    options={[
                      { value: "LOT", label: "LOT" },
                      { value: "QTY", label: "QTY" },
                    ]}
                    onChange={(option) =>
                      setSelectedRowData({ ...selectedRowData, type: option.value })
                    }
                  />
                </Col>
                <Col>
                  <label>POSITION LIMIT</label>
                  <Form.Control
                    type="number"
                    value={selectedRowData.positionLimit}
                    theme={the}
                    styles={customStyles}
                    className='bg-light text-black'
                    onChange={(e) =>
                      setSelectedRowData({ ...selectedRowData, positionLimit: e.target.value })
                    }
                  />
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => handleUpdate(selectedRowData)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCopyModal} onHide={handleCopyClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Quantity Setting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <Row>
            <Col xl={2} md={2} xs={3}>
              {['radio'].map((type) => (
                  <div key={`inline-${type}`}>
                  <Form.Check
                        inline
                        className=' fss-08'
                        label="CLIENT"
                        name="group1"
                        type={type}
                        id={`inline-${type}-1`}
                        checked={userType === 'CLIENT'}
                        onChange={() => setUserType('CLIENT')}
                      />
                  </div>
                ))}
            </Col>
            <Col xl={2} md={2} xs={3}>
            {user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType == 'SUPER_MASTER' ? (
              <>
              {['radio'].map((type) => (
                <div key={`inline-${type}`}>
                 <Form.Check
                      inline
                      className='fss-08'
                      label="MASTER"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={userType === 'MASTER'}
                       onChange={() => setUserType('MASTER')}
                    />
                    </div>
                ))}</>)
              :""}
              </Col>
              </Row>
              <Row>
                  { userType === 'MASTER' ?
                    <>
                      <Col xl={6} md={6} xs={6}>
                        <b className="fss-05">FROM</b>
                        <MasterDropdown
                          adminId={user.adminId}
                          //selectedAdmin={selectedAdmin}
                          setSelectedOption={setFrom}
                          //setSelectedMaster={setSelectedMaster}
                        />
                      </Col>
                      <Col xl={6} md={6} xs={6}>
                        <b className="fss-05">TO</b>
                        <MasterDropdown
                          adminId={user.adminId}
                          //selectedAdmin={selectedAdmin}
                          setSelectedOption={setTo}
                          //setSelectedMaster={setSelectedMaster}
                        />
                      </Col>
                    </> : ""} 
                    { userType === 'CLIENT' ?
                      <>
                        <Col xl={6} md={6} xs={6}>
                          <b className="fss-05">FROM</b>
                          <ClientDropdown
                           // selectedAdmin={selectedAdmin}
                          //  selectedMaster={selectedMaster}
                            setSelectedOption={setFrom}
                          />
                        </Col>
                        <Col xl={6} md={6} xs={6}>
                          <b className="fss-05">TO</b>
                          <ClientDropdown
                            //selectedAdmin={selectedAdmin}
                            //selectedMaster={selectedMaster}
                            setSelectedOption={setTo}
                          />
                        </Col>
                      </> : ""}
              </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCopyClose}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => handleCopySubmit()}
          >
            Copy
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default QuantitySettings;